import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const ScrollToTopOnMount = ({ location: { pathname } }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default withRouter(ScrollToTopOnMount);